import React from 'react';
import PropTypes from 'prop-types';
import { slasher } from '../helpers';

class Hero extends React.Component {
  constructor(props) {
    super(props);
    this.handleDirect = this.handleDirect.bind(this);
  }

  handleDirect() {
    window.location = `/`;
  }

  render() {
    const { history, isInterior, subhead, heading } = this.props;
    const { goBack, length } = history;

    const slash = slasher(heading || 'Heading');

    return (
      <section className="hero hero--int">
        {isInterior ? (
          <div className="wrapper wrapper--int">
            <button onClick={length > 1 ? goBack : this.handleDirect} className="btn--back">
              <i className="fas fa-chevron-left" /> &nbsp;Back
            </button>
          </div>
        ) : (
          ``
        )}
        <div className="wrapper hero__wrap">
          <h2 className="hero__subtitle">{subhead || ''}</h2>
          <h1 className="hero__title">{heading || 'Loading...'}</h1>
        </div>
      </section>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js